(function () {
  'use strict';

  document.querySelectorAll('[data-excel-reviews]').forEach(function (root) {
    var url = root.getAttribute('data-reviews-url');
    if (!url) return;

    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 5;
    var grid = root.querySelector('[data-reviews-grid]');
    var pagination = root.querySelector('[data-reviews-pagination]');
    var pageStatus = root.querySelector('[data-reviews-page-status]');
    var prevBtn = root.querySelector('[data-reviews-prev]');
    var nextBtn = root.querySelector('[data-reviews-next]');
    var errorEl = root.querySelector('[data-reviews-error]');

    var reviews = [];
    var currentPage = 1;

    function normalizeKey(key) {
      return String(key).trim().toLowerCase();
    }

    function pickField(row, candidates) {
      var keys = Object.keys(row);
      for (var i = 0; i < candidates.length; i++) {
        var match = keys.find(function (k) { return normalizeKey(k) === candidates[i]; });
        if (match) return row[match];
      }
      return '';
    }

    function starsHtml(rating) {
      var r = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
      var out = '';
      for (var i = 1; i <= 5; i++) out += i <= r ? '★' : '☆';
      return out;
    }

    var cardGradients = [
      'linear-gradient(150deg, #E8F3F1, #F8F2E7)',
      'linear-gradient(150deg, #FBEAEE, #F8F1E9)',
      'linear-gradient(150deg, #FCF0DA, #F6F0E6)'
    ];

    function initialLetter(name) {
      return (name || '').trim().charAt(0).toUpperCase() || '?';
    }

    function renderPage(page) {
      currentPage = page;
      var start = (page - 1) * perPage;
      var pageItems = reviews.slice(start, start + perPage);

      grid.innerHTML = pageItems.map(function (review, i) {
        var bg = cardGradients[i % cardGradients.length];
        return (
          '<li class="product-reviews__card" style="background: ' + bg + ';">' +
            '<div class="product-reviews__card-top">' +
              '<div class="product-reviews__stars" aria-hidden="true">' + starsHtml(review.rating) + '</div>' +
              '<span class="product-reviews__verified">✓ Verified</span>' +
            '</div>' +
            '<p class="product-reviews__quote">“' + review.quote + '”</p>' +
            '<div class="product-reviews__person">' +
              '<span class="product-reviews__avatar">' + initialLetter(review.name) + '</span>' +
              '<span>' +
                '<span class="product-reviews__name">' + review.name + '</span>' +
                (review.meta ? '<span class="product-reviews__meta">' + review.meta + '</span>' : '') +
              '</span>' +
            '</div>' +
          '</li>'
        );
      }).join('');

      var totalPages = Math.max(1, Math.ceil(reviews.length / perPage));
      if (pageStatus) pageStatus.textContent = 'Page ' + page + ' of ' + totalPages;
      if (prevBtn) prevBtn.disabled = page <= 1;
      if (nextBtn) nextBtn.disabled = page >= totalPages;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (currentPage > 1) renderPage(currentPage - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var totalPages = Math.max(1, Math.ceil(reviews.length / perPage));
      if (currentPage < totalPages) renderPage(currentPage + 1);
    });

    function announceRatingSummary() {
      if (!reviews.length) return;
      var sum = reviews.reduce(function (acc, r) { return acc + (Number(r.rating) || 0); }, 0);
      var average = sum / reviews.length;
      window.dispatchEvent(new CustomEvent('crowns:reviews-loaded', {
        detail: { average: average, count: reviews.length }
      }));
    }

    function parseRows(rows) {
      reviews = rows
        .map(function (row) {
          return {
            rating: pickField(row, ['rating', 'stars', 'score']),
            name: pickField(row, ['name', 'reviewer', 'customer']),
            quote: pickField(row, ['review', 'quote', 'comment', 'text']),
            meta: pickField(row, ['meta', 'location', 'city'])
          };
        })
        .filter(function (r) { return r.quote; });

      if (!reviews.length) {
        showError();
        return;
      }

      if (pagination) pagination.hidden = reviews.length <= perPage;
      renderPage(1);
      announceRatingSummary();
    }

    function init() {
      if (typeof XLSX === 'undefined') {
        showError();
        return;
      }

      var isCsv = /\.csv(\?|$)/i.test(url);

      if (isCsv) {
        fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error('Fetch failed');
            return res.text();
          })
          .then(function (csvText) {
            var workbook = XLSX.read(csvText, { type: 'string' });
            var sheet = workbook.Sheets[workbook.SheetNames[0]];
            parseRows(XLSX.utils.sheet_to_json(sheet, { defval: '' }));
          })
          .catch(function () { showError(); });
      } else {
        fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error('Fetch failed');
            return res.arrayBuffer();
          })
          .then(function (buffer) {
            var workbook = XLSX.read(buffer, { type: 'array' });
            var sheet = workbook.Sheets[workbook.SheetNames[0]];
            parseRows(XLSX.utils.sheet_to_json(sheet, { defval: '' }));
          })
          .catch(function () { showError(); });
      }
    }

    function showError() {
      if (errorEl) errorEl.classList.remove('hide');
    }

    init();
  });
})();
